import { render, staticRenderFns } from "./gongSiList.vue?vue&type=template&id=afb3d708&scoped=true&"
import script from "./gongSiList.vue?vue&type=script&lang=js&"
export * from "./gongSiList.vue?vue&type=script&lang=js&"
import style0 from "./gongSiList.vue?vue&type=style&index=0&id=afb3d708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb3d708",
  null
  
)

export default component.exports